var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmptyMail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "134px",
    height: "134px",
    viewBox: "0 0 134 134",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "A3665A6C-B7C9-47EB-BB5C-94A8F3DC20F6") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u21B3-applications",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Application-tasks---empty-state",
    transform: "translate(-1141, -111)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(1086, 111)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(55, 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(66.8361, 67) rotate(42) translate(-66.8361, -67)translate(20.5602, 18.5096)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#E6E6E6",
    transform: "translate(7.5756, 23.1804) rotate(-21.1614) translate(-7.5756, -23.1804)",
    cx: 7.57557121,
    cy: 23.1804003,
    rx: 2.57248648,
    ry: 1.78955685
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#3F3D56",
    transform: "translate(24.2577, 21.0404) rotate(-21.1614) translate(-24.2577, -21.0404)",
    cx: 24.2576598,
    cy: 21.0404274,
    rx: 2.57248648,
    ry: 1.78955344
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#E7EBFD",
    transform: "translate(6.1288, 37.413) rotate(-21.1614) translate(-6.1288, -37.413)",
    cx: 6.12878661,
    cy: 37.4130048,
    rx: 2.57248648,
    ry: 1.78955685
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#E7EBFD",
    transform: "translate(7.3304, 30.2582) rotate(-13.3164) translate(-7.3304, -30.2582)",
    cx: 7.33043717,
    cy: 30.2581613,
    rx: 1.13099859,
    ry: 1.62581175
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#E7EBFD",
    transform: "translate(32.5942, 88.446) rotate(-49.5954) translate(-32.5942, -88.446)",
    cx: 32.5941612,
    cy: 88.4460308,
    rx: 1.78955685,
    ry: 2.57248648
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#E7EBFD",
    transform: "translate(25.7303, 90.7961) rotate(-41.7504) translate(-25.7303, -90.7961)",
    cx: 25.7302722,
    cy: 90.796056,
    rx: 1.62581175,
    ry: 1.13099859
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#E7EBFD",
    transform: "translate(71.9127, 5.5644) rotate(-26.188) translate(-71.9127, -5.5644)",
    cx: 71.9126621,
    cy: 5.56443737,
    rx: 1.78955685,
    ry: 2.57248648
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#E7EBFD",
    transform: "translate(79.1453, 6.1346) rotate(-18.343) translate(-79.1453, -6.1346)",
    cx: 79.1452747,
    cy: 6.13457827,
    rx: 1.62581175,
    ry: 1.13099859
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#E6E6E6",
    transform: "translate(1.5743, 43.7779) rotate(-13.3164) translate(-1.5743, -43.7779)",
    cx: 1.57432579,
    cy: 43.7778539,
    rx: 1.13099859,
    ry: 1.62581175
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#3F3D56",
    transform: "translate(1.4751, 54.4068) rotate(-13.3164) translate(-1.4751, -54.4068)",
    cx: 1.47505893,
    cy: 54.4068455,
    rx: 1.13099859,
    ry: 1.62581175
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#E6E6E6",
    transform: "translate(16.1165, 32.3917) rotate(-13.3164) translate(-16.1165, -32.3917)",
    cx: 16.1164583,
    cy: 32.3917312,
    rx: 1.13099859,
    ry: 1.62581175
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#3F3D56",
    transform: "translate(16.643, 20.4706) rotate(-13.3164) translate(-16.643, -20.4706)",
    cx: 16.6429822,
    cy: 20.4706452,
    rx: 1.13099859,
    ry: 1.62581175
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#E6E6E6",
    transform: "translate(19.3896, 93.9506) rotate(-49.5954) translate(-19.3896, -93.9506)",
    cx: 19.3896073,
    cy: 93.9505788,
    rx: 1.78955685,
    ry: 2.57248648
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#3F3D56",
    transform: "translate(9.5647, 80.2999) rotate(-49.5954) translate(-9.5647, -80.2999)",
    cx: 9.56467718,
    cy: 80.2998551,
    rx: 1.78955344,
    ry: 2.57248648
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#E6E6E6",
    transform: "translate(40.3598, 89.4204) rotate(-41.7504) translate(-40.3598, -89.4204)",
    cx: 40.3597763,
    cy: 89.4204307,
    rx: 1.62581175,
    ry: 1.13099859
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#3F3D56",
    transform: "translate(49.7538, 84.4468) rotate(-41.7504) translate(-49.7538, -84.4468)",
    cx: 49.7538161,
    cy: 84.4467636,
    rx: 1.62581175,
    ry: 1.13099859
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#E6E6E6",
    transform: "translate(23.423, 82.054) rotate(-41.7504) translate(-23.423, -82.054)",
    cx: 23.4230241,
    cy: 82.0540368,
    rx: 1.62581175,
    ry: 1.13099859
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#3F3D56",
    transform: "translate(12.6893, 87.2672) rotate(-41.7504) translate(-12.6893, -87.2672)",
    cx: 12.6893274,
    cy: 87.2672092,
    rx: 1.62581175,
    ry: 1.13099859
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#E6E6E6",
    transform: "translate(86.2173, 5.7586) rotate(-26.188) translate(-86.2173, -5.7586)",
    cx: 86.2172946,
    cy: 5.75861855,
    rx: 1.78955685,
    ry: 2.57248648
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#3F3D56",
    transform: "translate(89.8107, 22.189) rotate(-26.188) translate(-89.8107, -22.189)",
    cx: 89.8106938,
    cy: 22.1890489,
    rx: 1.78955344,
    ry: 2.57248648
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#E6E6E6",
    transform: "translate(65.1732, 1.5852) rotate(-18.343) translate(-65.1732, -1.5852)",
    cx: 65.1732374,
    cy: 1.58518258,
    rx: 1.62581175,
    ry: 1.13099859
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#3F3D56",
    transform: "translate(54.5764, 2.4176) rotate(-18.343) translate(-54.5764, -2.4176)",
    cx: 54.5764229,
    cy: 2.41759688,
    rx: 1.62581175,
    ry: 1.13099859
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#E6E6E6",
    transform: "translate(77.7897, 15.0737) rotate(-18.343) translate(-77.7897, -15.0737)",
    cx: 77.7897309,
    cy: 15.0737485,
    rx: 1.62581175,
    ry: 1.13099859
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#3F3D56",
    transform: "translate(89.7111, 14.5537) rotate(-18.343) translate(-89.7111, -14.5537)",
    cx: 89.7111018,
    cy: 14.5537415,
    rx: 1.62581175,
    ry: 1.13099859
  })), /*#__PURE__*/React.createElement("path", {
    d: "M100.434151,69 L100.411323,69 L87.3201154,74.549434 L69.408645,82.142269 C69.2672939,82.2012955 69.1081029,82.2021097 68.9661466,82.1445323 L50.4867833,74.5335819 L37.0739631,69.009055 L37.0534721,69 L37.0306426,69 C36.5899861,69.0004849 36.2323968,69.3549943 36.2323968,69.792453 L36.2323968,104.207547 C36.2323968,104.645006 36.5899861,104.999515 37.0306426,105 L100.434151,105 C100.874808,104.999515 101.232397,104.645006 101.232397,104.207547 L101.232397,69.792453 C101.232397,69.3549943 100.874808,69.0004849 100.434151,69 L100.434151,69 Z",
    id: "Path",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.118039,70 C101.09471,70 101.07194,69.9929789 101.052804,69.9798513 L69.4459115,48.3251535 C69.248914,48.1908174 68.9877514,48.1912553 68.7912205,48.3262512 L37.412008,69.979631 C37.3603245,70.0150133 37.2892876,70.0026149 37.2531308,69.9519013 C37.2169741,69.9011878 37.2293144,69.8312585 37.2807306,69.7955013 L68.6599688,48.1421305 C68.9351322,47.9531673 69.3007532,47.952576 69.5765466,48.1406483 L101.183434,69.7952829 C101.224411,69.8233752 101.242105,69.8743878 101.227129,69.9212626 C101.212153,69.9681375 101.167976,70 101.11803,70 L101.118039,70 Z",
    id: "Path",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#E6E6E6",
    points: "38.2323968 69.7877976 68.1189239 48 98.2323968 71.3380329 69.6588226 88 54.1459046 84.5218801"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.5478406,99 L41.9169531,99 C41.5394414,99.0004075 41.2329555,98.7768809 41.2323968,98.5007389 C41.2318397,98.2245968 41.5374212,98.0004086 41.9149329,98 L56.5478406,98 C56.9253523,97.9995925 57.2318382,98.2231191 57.2323968,98.4992611 C57.2329539,98.7754032 56.9273725,98.9995914 56.5498607,99 L56.5478406,99 Z",
    id: "Path",
    fill: "#0033FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.611374,96 L41.8525694,96 C41.5104945,96.0002181 41.232903,95.7767468 41.2323968,95.5007389 C41.231892,95.2247309 41.5086638,95.0005986 41.8507379,95 L46.611374,95 C46.8328657,94.9996146 47.0377721,95.0946429 47.1488454,95.2492612 C47.2599188,95.4038795 47.2602684,95.5945753 47.1497624,95.7494581 C47.0392563,95.9043408 46.8346992,95.9998577 46.6132071,96 L46.611374,96 Z",
    id: "Path",
    fill: "#0033FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.013313,82 C68.9009619,82 68.7896669,81.9786417 68.6856643,81.9367796 L50.2323968,74.3948593 L50.2323968,50.7873883 C50.2329112,50.3527365 50.5905048,50.0005076 51.0317779,50 L86.433014,50 C86.8742873,50.0005076 87.2318815,50.3527362 87.2323968,50.7873883 L87.2323968,74.4113362 L87.1977142,74.4259473 L69.3508918,81.9330984 C69.2440166,81.9773361 69.1292413,82 69.013313,82 L69.013313,82 Z",
    id: "Path",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.0124487,82 C68.8930161,82 68.7747028,81.9773396 68.6641279,81.9328987 L50.2323968,74.4029306 L50.2323968,50.840675 C50.2329298,50.3766006 50.6148971,50.0005247 51.0862416,50 L86.3785503,50 C86.8498951,50.0005247 87.2318629,50.3766003 87.2323968,50.840675 L87.2323968,74.418916 L69.3713361,81.9288524 C69.2577299,81.975917 69.135702,82 69.0124487,82 L69.0124487,82 Z M50.4600811,74.2531883 L68.7509563,81.7256369 C68.9215585,81.7937909 69.1126279,81.7926694 69.2823926,81.7225176 L87.0047035,74.2709215 L87.0047035,50.840675 C87.0042884,50.5003649 86.7241916,50.2245923 86.3785503,50.2241886 L51.0862416,50.2241886 C50.7406003,50.2245923 50.4605034,50.5003649 50.4600811,50.840675 L50.4600811,74.2531883 Z",
    id: "Shape",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.434151,69 L100.411323,69 L87.3201103,74.549434 L69.4086404,82.142269 C69.2672893,82.2012955 69.1080983,82.2021097 68.9661421,82.1445323 L50.4867884,74.5335819 L37.0739686,69.009055 L37.0534776,69 L37.0306426,69 C36.5899861,69.0004849 36.2323968,69.3549943 36.2323968,69.792453 L36.2323968,104.207547 C36.2323968,104.645006 36.5899861,104.999515 37.0306426,105 L100.434151,105 C100.874808,104.999515 101.232397,104.645006 101.232397,104.207547 L101.232397,69.792453 C101.232397,69.3549943 100.874808,69.0004849 100.434151,69 Z M101.004327,104.207547 C101.004327,104.52011 100.748999,104.773586 100.434151,104.773586 L37.0306426,104.773586 C36.7157952,104.773586 36.4604663,104.52011 36.4604663,104.207547 L36.4604663,69.792453 C36.4604663,69.4883076 36.7028608,69.2386146 37.0089833,69.2264162 L50.4867884,74.7781116 L68.8783987,82.353962 C69.0774836,82.4343776 69.3005628,82.4331564 69.4987423,82.3505661 L87.3201103,74.7950981 L100.456981,69.2264162 C100.762508,69.2395161 101.00362,69.4888627 101.004327,69.7924548 L101.004327,104.207547 Z",
    id: "Shape",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.3446071,59 L53.1201866,59 C52.6296705,58.9992183 52.2323968,58.5517321 52.2323968,58 C52.2323968,57.4482679 52.6296705,57.0007817 53.1201866,57 L65.3446071,57 C65.8351232,57.0007817 66.2323968,57.4482679 66.2323968,58 C66.2323968,58.5517321 65.8351232,58.9992183 65.3446071,59 L65.3446071,59 Z",
    id: "Path",
    fill: "#0033FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.3048609,55 L53.1599327,55 C52.6476688,55 52.2323968,54.5522847 52.2323968,54 C52.2323968,53.4477153 52.6476688,53 53.1599327,53 L59.3048609,53 C59.8171249,53 60.2323968,53.4477153 60.2323968,54 C60.2323968,54.5522847 59.8171249,55 59.3048609,55 L59.3048609,55 Z",
    id: "Path",
    fill: "#0033FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.320534,68 L59.1442596,68 C58.6404429,67.9992183 58.2323968,67.5517321 58.2323968,67 C58.2323968,66.4482679 58.6404429,66.0007817 59.1442596,66 L78.320534,66 C78.8243508,66.0007817 79.2323968,66.4482679 79.2323968,67 C79.2323968,67.5517321 78.8243508,67.9992183 78.320534,68 L78.320534,68 Z",
    id: "Path",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.3193528,73 L59.1454409,73 C58.6411806,73 58.2323968,72.5522847 58.2323968,72 C58.2323968,71.4477153 58.6411806,71 59.1454409,71 L78.3193528,71 C78.8236131,71 79.2323968,71.4477153 79.2323968,72 C79.2323968,72.5522847 78.8236131,73 78.3193528,73 L78.3193528,73 Z",
    id: "Path",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#0033FF",
    cx: 100.232397,
    cy: 70,
    r: 9
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    points: "98.7406121 73 96.2323968 69.8058218 97.6910112 68.6822266 98.878601 70.1946037 102.890719 66 104.232397 67.2588542"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyMail);
export default __webpack_public_path__ + "static/media/emptyMail.5db006500ae1a21399bf2fbb45b6e204.svg";
export { ForwardRef as ReactComponent };